<template>
    <div>
        <NewHeader></NewHeader>
        <div class="container bg-neutral-900 mt-[68px] md:mt-[88px] py-5">
            <div class="last-updated">{{ t('terms.last_updated') }}</div>
            <h1>{{ t('terms.welcome_title') }}</h1>
            <p>{{ t('terms.intro_paragraph_1') }}</p>
            <p>{{ t('terms.intro_paragraph_2') }}</p>

            <h2>{{ t('terms.sections.section_1.title') }}</h2>
            <h3>{{ t('terms.sections.section_1.subsection_1_1.title') }}</h3>
            <p>{{ t('terms.sections.section_1.subsection_1_1.content') }}</p>
            <h3>{{ t('terms.sections.section_1.subsection_1_2.title') }}</h3>
            <p>{{ t('terms.sections.section_1.subsection_1_2.content') }}</p>

            <h2>{{ t('terms.sections.section_2.title') }}</h2>
            <p>{{ t('terms.sections.section_2.intro') }}</p>
            <ul>
                <li>{{ t('terms.sections.section_2.items.0') }}</li>
                <li>{{ t('terms.sections.section_2.items.1') }}</li>
                <li>{{ t('terms.sections.section_2.items.2') }}</li>
                <li>{{ t('terms.sections.section_2.items.3') }}</li>
            </ul>

            <h2>{{ t('terms.sections.section_3.title') }}</h2>
            <h3>{{ t('terms.sections.section_3.subsection_3_1.title') }}</h3>
            <p>{{ t('terms.sections.section_3.subsection_3_1.content') }}</p>
            <h3>{{ t('terms.sections.section_3.subsection_3_2.title') }}</h3>
            <p>{{ t('terms.sections.section_3.subsection_3_2.content') }}</p>

            <h2>{{ t('terms.sections.section_4.title') }}</h2>
            <h3>{{ t('terms.sections.section_4.subsection_4_1.title') }}</h3>
            <p>{{ t('terms.sections.section_4.subsection_4_1.intro') }}</p>
            <ul>
                <li>{{ t('terms.sections.section_4.subsection_4_1.items.0') }}</li>
                <li>{{ t('terms.sections.section_4.subsection_4_1.items.1') }}</li>
                <li>{{ t('terms.sections.section_4.subsection_4_1.items.2') }}</li>
                <li>{{ t('terms.sections.section_4.subsection_4_1.items.3') }}</li>
                <li>{{ t('terms.sections.section_4.subsection_4_1.items.4') }}</li>
                <li>{{ t('terms.sections.section_4.subsection_4_1.items.5') }}</li>
                <li>{{ t('terms.sections.section_4.subsection_4_1.items.6') }}</li>
            </ul>
            <h3>{{ t('terms.sections.section_4.subsection_4_2.title') }}</h3>
            <p>{{ t('terms.sections.section_4.subsection_4_2.intro') }}</p>
            <ul>
                <li>{{ t('terms.sections.section_4.subsection_4_2.items.0') }}</li>
                <li>{{ t('terms.sections.section_4.subsection_4_2.items.1') }}</li>
                <li>{{ t('terms.sections.section_4.subsection_4_2.items.2') }}</li>
                <li>{{ t('terms.sections.section_4.subsection_4_2.items.3') }}</li>
                <li>{{ t('terms.sections.section_4.subsection_4_2.items.4') }}</li>
                <li>{{ t('terms.sections.section_4.subsection_4_2.items.5') }}</li>
                <li>{{ t('terms.sections.section_4.subsection_4_2.items.6') }}</li>
                <li>{{ t('terms.sections.section_4.subsection_4_2.items.7') }}</li>
            </ul>
            <p>{{ t('terms.sections.section_4.subsection_4_2.removal_notice') }}</p>

            <h2>{{ t('terms.sections.section_5.title') }}</h2>
            <h3>{{ t('terms.sections.section_5.subsection_5_1.title') }}</h3>
            <p>{{ t('terms.sections.section_5.subsection_5_1.intro') }}</p>
            <ul>
                <li>{{ t('terms.sections.section_5.subsection_5_1.items.0') }}</li>
                <li>{{ t('terms.sections.section_5.subsection_5_1.items.1') }}</li>
                <li>{{ t('terms.sections.section_5.subsection_5_1.items.2') }}</li>
                <li>{{ t('terms.sections.section_5.subsection_5_1.items.3') }}</li>
                <li>{{ t('terms.sections.section_5.subsection_5_1.items.4') }}</li>
            </ul>
            <h3>{{ t('terms.sections.section_5.subsection_5_2.title') }}</h3>
            <p>{{ t('terms.sections.section_5.subsection_5_2.content') }}</p>
            <p>{{ t('terms.sections.section_5.subsection_5_2.termination_notice') }}</p>

            <h2>{{ t('terms.sections.section_6.title') }}</h2>
            <p>{{ t('terms.sections.section_6.content') }}</p>

            <h2>{{ t('terms.sections.section_7.title') }}</h2>
            <p>{{ t('terms.sections.section_7.content') }}</p>

            <h2>{{ t('terms.sections.section_8.title') }}</h2>
            <p>{{ t('terms.sections.section_8.content') }}</p>

            <h2>{{ t('terms.sections.section_9.title') }}</h2>
            <p>{{ t('terms.sections.section_9.content') }}</p>

            <h2>{{ t('terms.sections.section_10.title') }}</h2>
            <p>{{ t('terms.sections.section_10.content') }}</p>

            <h2>{{ t('terms.sections.section_11.title') }}</h2>
            <h3>{{ t('terms.sections.section_11.subsection_11_1.title') }}</h3>
            <p>{{ t('terms.sections.section_11.subsection_11_1.content') }}</p>
            <h3>{{ t('terms.sections.section_11.subsection_11_2.title') }}</h3>
            <p>{{ t('terms.sections.section_11.subsection_11_2.content') }}</p>

            <h2>{{ t('terms.sections.section_12.title') }}</h2>
            <h3>{{ t('terms.sections.section_12.subsection_12_1.title') }}</h3>
            <p>{{ t('terms.sections.section_12.subsection_12_1.content') }}</p>
            <h3>{{ t('terms.sections.section_12.subsection_12_2.title') }}</h3>
            <p>{{ t('terms.sections.section_12.subsection_12_2.content') }}</p>
            <h3>{{ t('terms.sections.section_12.subsection_12_3.title') }}</h3>
            <p>{{ t('terms.sections.section_12.subsection_12_3.content') }}</p>
            <h3>{{ t('terms.sections.section_12.subsection_12_4.title') }}</h3>
            <p>{{ t('terms.sections.section_12.subsection_12_4.content') }}</p>

            <h2>{{ t('terms.sections.section_13.title') }}</h2>
            <p>{{ t('terms.sections.section_13.intro') }}</p>

            <h3>{{ t('terms.sections.section_13.subsection_13_1.title') }}</h3>
            <p>{{ t('terms.sections.section_13.subsection_13_1.intro') }}</p>
            <ul>
                <li>{{ t('terms.sections.section_13.subsection_13_1.benefits.0') }}</li>
                <li>{{ t('terms.sections.section_13.subsection_13_1.benefits.1') }}</li>
                <li>{{ t('terms.sections.section_13.subsection_13_1.benefits.2') }}</li>
                <li>{{ t('terms.sections.section_13.subsection_13_1.benefits.3') }}</li>
                <li>{{ t('terms.sections.section_13.subsection_13_1.benefits.4') }}</li>
                <li>{{ t('terms.sections.section_13.subsection_13_1.benefits.5') }}</li>
                <li>{{ t('terms.sections.section_13.subsection_13_1.benefits.6') }}</li>
                <li>{{ t('terms.sections.section_13.subsection_13_1.benefits.7') }}</li>
            </ul>

            <h3>{{ t('terms.sections.section_13.subsection_13_2.title') }}</h3>
            <p>{{ t('terms.sections.section_13.subsection_13_2.fee_info') }}</p>
            <p>{{ t('terms.sections.section_13.subsection_13_2.renewal_info') }}</p>
            <p>{{ t('terms.sections.section_13.subsection_13_2.dispute_resolution') }}</p>

            <h3>{{ t('terms.sections.section_13.subsection_13_3.title') }}</h3>
            <p>
                {{ t('terms.sections.section_13.subsection_13_3.cancellation_instructions') }} <NuxtLink to="/contact" class="underline-offset-4 underline">{{ t('terms.sections.section_13.subsection_13_3.feedback_form_link') }}</NuxtLink>. {{ t('terms.sections.section_13.subsection_13_3.advance_notice') }}
            </p>
            <p>{{ t('terms.sections.section_13.subsection_13_3.no_refund_notice') }}</p>

            <h3>{{ t('terms.sections.section_13.subsection_13_4.title') }}</h3>
            <p>{{ t('terms.sections.section_13.subsection_13_4.transparency_commitment') }}</p>
            <p>
                {{ t('terms.sections.section_13.subsection_13_4.agreement_notice') }} <NuxtLink to="/contact" class="underline-offset-4 underline">{{ t('terms.sections.section_13.subsection_13_4.contact_link') }}</NuxtLink> {{ t('terms.sections.section_13.subsection_13_4.support_team') }}
            </p>

            <h2>{{ t('terms.sections.section_14.title') }}</h2>
            <h3>{{ t('terms.sections.section_14.subsection_14_1.title') }}</h3>
            <p>{{ t('terms.sections.section_14.subsection_14_1.eligibility') }}</p>
            <p>{{ t('terms.sections.section_14.subsection_14_1.non_refundable_intro') }}</p>
            <ul>
                <li>{{ t('terms.sections.section_14.subsection_14_1.non_refundable_conditions.0') }}</li>
                <li>{{ t('terms.sections.section_14.subsection_14_1.non_refundable_conditions.1') }}</li>
                <li>{{ t('terms.sections.section_14.subsection_14_1.non_refundable_conditions.2') }}</li>
                <li>{{ t('terms.sections.section_14.subsection_14_1.non_refundable_conditions.3') }}</li>
            </ul>

            <h3>{{ t('terms.sections.section_14.subsection_14_2.title') }}</h3>
            <p>
                {{ t('terms.sections.section_14.subsection_14_2.refund_process') }} <NuxtLink to="/contact" class="underline-offset-4 underline">{{ t('terms.sections.section_14.subsection_14_2.feedback_form_link') }}</NuxtLink>. {{ t('terms.sections.section_14.subsection_14_2.verification_notice') }}
            </p>

            <h2>{{ t('terms.sections.section_15.title') }}</h2>
            <p>
                {{ t('terms.sections.section_15.contact_intro') }} <NuxtLink to="/contact" class="underline-offset-4 underline">{{ t('terms.sections.section_15.contact_link') }}</NuxtLink> {{ t('terms.sections.section_15.page_text') }}
            </p>
        </div>
        <NewFooter></NewFooter>
    </div>
</template>

<script setup>
  import NewHeader from '~/components/NewHeader';
  import NewFooter from '~/components/NewFooter';
  
  const { t } = useI18n();

  useHead({
    title: t('terms.page_title'),
    meta: [
        {
            name: 'description',
            content: t('terms.meta_description')
        }
    ]
});

  </script>

<style scoped>
body {
    font-family: Arial, sans-serif;
    line-height: 1.6;
    margin: 0;
    padding: 0;
    background-color: #f4f4f4;
}

.container {
    max-width: 1280px;
    margin: 20px auto;
    padding: 0 32px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1,
h2,
h3 {
    color: #fff;
}

h1 {
    font-size: 24px;
    margin-bottom: 20px;
}

h2 {
    font-size: 20px;
    margin-top: 20px;
}

h3 {
    font-size: 18px;
    margin-top: 15px;
}

p {
    margin: 10px 0;
}

ul {
    margin: 10px 0 10px 20px;
}

li {
    margin: 5px 0;
}

.last-updated {
    text-align: right;
    font-size: 12px;
    color: #666;
}
</style>